/* Gatsby Browser API
 * -------------------
 * The file gatsby-browser.js lets you respond to Gatsby-specific events within
 * the browser, and wrap your page components in additional global components.
 * The Gatsby Browser API gives you many options for interacting with the
 * client-side of Gatsby.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react";
import reactDom from "react-dom/client";
import { navigate } from "gatsby";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";

import repositoryConfigs from "./config/prismic-previews-provider-config";

import redirectMap from "./src/generated/redirects.js";

export const onRouteUpdate = ({ location }) => {
  let pathname = decodeURI(location.pathname);
  const destination =
    redirectMap[pathname] ||
    redirectMap[`${pathname}/`] ||
    redirectMap[pathname.replace(/\/$/, "")];
  if (destination && destination !== pathname) {
    navigate(destination, { replace: true });
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
      {element}
    </PrismicPreviewProvider>
  );
};

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = reactDom.createRoot(container);
    root.render(element);
  };
};

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0);
  return false;
};

// Inject only CookieYes script on the client side with proper error handling
export const onClientEntry = () => {
  window.addEventListener('load', () => {
    setTimeout(() => {
      try {
        const script = document.createElement('script');
        script.id = 'cookieyes';
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://cdn-cookieyes.com/client_data/48747b73de5379ee61946bc5/script.js';
        
        script.onerror = () => {
          console.warn('CookieYes script failed to load, but website will continue to function.');
        };
        
        document.head.appendChild(script);
      } catch (error) {
        console.warn('Error adding CookieYes script:', error);
      }
    }, 1000); 
  });
};
